import { City, Place, Product } from 'rest-client';

export class SetBookingInitialDataAction {
  static readonly type = '[BOOKING] Set booking initial data';
  constructor(
    public startDate: string,
    public endDate: string,
    public placeId: number
  ) { }
}

export class SetBookingDataAction {
  static readonly type = '[BOOKING] Set booking data';
  constructor(
    public startDate: string,
    public endDate: string,
    public place: Place,
    public product: Product
  ) { }
}

export class RemoveBookingInitialDataAction {
  static readonly type = '[BOOKING] Remove booking initial data';
}

export class SetCitiesAction {
  static readonly type = '[BOOKING] Set cities';
  constructor(public cities: City[]) { }
}

export class RemoveCitiesAction {
  static readonly type = '[BOOKING] Remove cities';
}

export class SetProductIdAction {
  static readonly type = '[BOOKING] Set product id';
  constructor(public productId: number) { }
}

export class RemoveProductIdAction {
  static readonly type = '[BOOKING] Remove product id';
}

export class SetBookingDatesAction {
  static readonly type = '[BOOKING] Set booking dates';
  constructor(public startDate: string, public endDate: string) { }
}

export class RemoveBookingDatesAction {
  static readonly type = '[BOOKING] Remove booking dates';
}

export class RemoveBookingAction {
  static readonly type = '[BOOKING] Remove all booking';
}
